import React, { useState } from "react";
// import outline from "../../assets/icons/blogs_page.svg";
import blogs from "../data/blogsdata";
import { ArrowUpRight, ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

const BlogsAll = () => {
  const itemsPerPage = 6;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(blogs.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentBlogs = blogs.slice(startIndex, endIndex);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  return (
    <div className=" xl:py-28 lg:py-20 md:py-14 py-10 relative ">
      <div data-aos="fade-up" className="xl:w-4/5 2xl:px-0 xl:px-10 px-0 w-11/12 mx-auto flex justify-center items-center relative flex-col z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
          {currentBlogs.map((blog) => (
            <article className=" group relative border overflow-hidden border-slate-200/90 rounded-xl p-6 flex flex-col justify-between hover:border-slate-300 hover:shadow-xl hover:shadow-slate-200/50 transition-all duration-300 bg-white">
              <div className="relative z-10 space-y-6">
                <div className="relative w-full h-56 sm:h-64 rounded-xl overflow-hidden bg-slate-100 border border-slate-200/80">
                  <img
                    src={blog.image}
                    alt={blog.title}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500 ease-out"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-950/40 via-transparent to-transparent" />
                  <div className="absolute bottom-4 left-4">
                    <span className="font-bold text-xs uppercase tracking-wider text-white px-3 py-1 rounded-md shadow-xs ">
                      {blog.date}
                    </span>
                  </div>
                </div>
                <div className="space-y-3">
                  <h3 className="text-xl sm:text-2xl font-bold text-[#000036] tracking-tight leading-snug  transition-colors">
                    {blog.title}
                  </h3>
                  <p className="text-sm sm:text-base text-slate-600 font-normal leading-relaxed">
                    {blog.summary}
                  </p>
                </div>
              </div>
              <div className="relative z-10 pt-6 mt-6 border-t border-slate-100">
                <Link
                  to={blog.slug}
                  className="group inline-flex items-center justify-between gap-3 px-6 py-2.5 border border-black/15 bg-white/70 text-slate-900 font-mono text-xs font-semibold uppercase tracking-widest transition-all duration-300 hover:bg-slate-950 hover:text-white hover:shadow-md rounded-full"
                >
                  <span> Read More</span>
                  <div className="h-6 w-6 rounded-full  flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1 group-hover:bg-white group-hover:text-slate-950">
                    <ArrowUpRight size={13} />
                  </div>
                </Link>
              </div>
            </article>
          ))}
        </div>
        <div className="flex items-center justify-center gap-3 mt-10">
          <button
            onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
            className={`px-2 py-2 text-matcha border border-matcha rounded-lg ${currentPage === 1
                ? "opacity-50  cursor-not-allowed"
                : "hover:bg-[#000036] hover:text-[#5dc9f0]"
              }`}
          >
            <ChevronLeft />
          </button>
          {[...Array(totalPages)].map((_, index) => {
            const page = index + 1;

            return (
              <button
                key={page}
                onClick={() => handlePageChange(page)}
                className={`w-10 h-10 rounded-lg border border-matcha font-bold font-quicksand text-matcha transition-all duration-300 ${currentPage === page
                    ? "bg-[#000036] text-[#5dc9f0]"
                    : "hover:bg-[#000036] hover:text-[#5dc9f0]"
                  }`}
              >
                {page}
              </button>
            );
          })}
          <button
            onClick={() =>
              currentPage < totalPages && handlePageChange(currentPage + 1)
            }
            className={`px-2 py-2 border text-matcha border-matcha rounded-lg ${currentPage === totalPages
                ? "opacity-50 cursor-not-allowed"
                : "hover:bg-[#000036] hover:text-[#5dc9f0]"
              }`}
          >
            <ChevronRight />
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlogsAll;
